import React from "react";
import { getGradientClass } from "../constants/theme";

export default function PartnerCard({ partner }) {
    return (
        <div className={`bg-gradient-to-br ${getGradientClass(partner.gradientIndex)} p-0.5 rounded-lg hover:scale-105 transition-transform duration-200`}>
            <div className="bg-gray-800 rounded-lg h-full">
                <div className="p-6">
                    <h3 className="text-xl font-bold text-white mb-2">{partner.title}</h3>
                    <p className="text-gray-300 mb-4">{partner.description}</p>
                    {partner.link && (
                        <a
                            href={partner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sky-400 hover:text-yellow-400 transition-colors"
                        >
                            {partner.linkText}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}
